import { createFileRoute, redirect } from '@tanstack/react-router'

// /vsl has no view of its own — send it to the first sub-section.
export const Route = createFileRoute('/_authenticated/vsl/')({
  beforeLoad: () => {
    throw redirect({ to: '/vsl/bases' })
  },
})
